import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

interface BackToHomeProps {
  className?: string;
}

const BackToHome: React.FC<BackToHomeProps> = ({ className = '' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/home');
  };

  return (
    <div className={`fixed top-20 left-6 z-50 ${className}`}>
      <button
        onClick={handleBack}
        className="flex items-center text-text-secondary hover:text-white transition-colors"
      >
        <ArrowBack className="mr-2" />
        Back to Home
      </button>
    </div>
  );
};

export default BackToHome;
